import type { ThemeRegistryEntry } from "../contracts";

export const SEMANTIC_TOKEN_TO_CSS_VARIABLE = {
    definition: "--semantic-definition",
    reference: "--semantic-reference",
    loopVariable: "--semantic-loop-variable",
    contentVariable: "--semantic-content-variable",
    warning: "--semantic-warning",
    error: "--semantic-error",
} as const;

export type SemanticTokenId = keyof typeof SEMANTIC_TOKEN_TO_CSS_VARIABLE;

const SEMANTIC_TOKEN_METADATA = {
    definition: "Definition-like semantic highlights.",
    reference: "Reference-like semantic highlights.",
    loopVariable: "Loop variable semantic highlights.",
    contentVariable: "Content variable semantic highlights.",
    warning: "Warning semantic highlights.",
    error: "Error semantic highlights.",
} as const satisfies Record<SemanticTokenId, string>;

export const SEMANTIC_TOKEN_REGISTRY: ThemeRegistryEntry<SemanticTokenId>[] = (
    Object.keys(SEMANTIC_TOKEN_TO_CSS_VARIABLE) as SemanticTokenId[]
).map((id) => ({
    id,
    cssVariable: SEMANTIC_TOKEN_TO_CSS_VARIABLE[id],
    description: SEMANTIC_TOKEN_METADATA[id],
    domain: "editor",
    public: true,
}));

export const KNOWN_SEMANTIC_TOKEN_VARIABLES = Object.values(
    SEMANTIC_TOKEN_TO_CSS_VARIABLE,
);

export const SEMANTIC_CSS_VARIABLE_TO_TOKEN = Object.fromEntries(
    Object.entries(SEMANTIC_TOKEN_TO_CSS_VARIABLE).map(([id, cssVariable]) => [
        cssVariable,
        id,
    ]),
) as Record<(typeof KNOWN_SEMANTIC_TOKEN_VARIABLES)[number], SemanticTokenId>;
